module.exports = __webpack_public_path__ + "static/img/wechat-enterprise.ce705b26.png";